<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper order-history-wrapper">
      <app-header>
        <div class="title-bar" slot="header-foot">
          <button @click="goBack()" class="button is-flex nav-back">
            <img src="@/assets/img/icon-nav-arrow-left.svg" alt="Go Back">
          </button>
            <h1 class="title">My Order History</h1>
        </div>
      </app-header>

      <main class="content-wrapper has-background-white-bis pb0">
        <div class="pg-title-block">
          <div class="container is-fluid">
            <div class="is-flex align-items-center">
              <div class="title-block is-flex flex-1 justify-content-between align-items-center">
             
                <router-link class="bg-secondary hover-opacity-7 order-history-browse-btn text-white" :to="{ name: 'StoreProfile', params: {business_slug: $route.params.business_slug, store_slug: vg_selectedStore.slug }, query: $route.query }">Browse products</router-link>
               
                <ul class="tabs history-switch-tab is-hidden-touch"><!-- is-hidden-touch-->
                  <li :class="vg_activeTab == 'past' ? 'is-active' : ''">
                    <a @click.prevent="switchOrderTab('past')" class>Past Orders</a>
                  </li>
                  <li :class="vg_activeTab == 'coming' ? 'is-active' : ''">
                    <a @click.prevent="switchOrderTab('coming')" class>Upcoming</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="columns mv0 flex-grow-1">
          <!-- TABS -->
          <div class="column has-border-right">
              <div class="hv-center" v-if="loading">
                  <loading></loading>
              </div>

            <ul v-else class="columns is-multiline tabs height-400 order-history-sidebar custom-scroll" id="height-400">

              <li :class="'column is-12 is-12-mobile is-12-tablet is-hidden-desktop ' + (vg_activeTab == 'past' ? 'is-active bg-primary' : '')">
                <a
                  @click.prevent="switchOrderTab('past')"
                  class="is-flex is-flex-column align-items-start"
                >
                  <span class="tab-label">Past Orders</span>
                </a>
              </li>
              <li :class="'column is-12 is-12-mobile is-12-tablet is-hidden-desktop ' + (vg_activeTab == 'coming' ? 'is-active bg-primary' : '')">
                <a
                  @click.prevent="switchOrderTab('coming')"
                  class="is-flex is-flex-column align-items-start"
                >
                  <span class="tab-label">Upcoming Orders</span>
                </a>
              </li>

              <!-- list of orders -->
              <template v-if="vg_activeTab == 'past'">
                <li
                  v-for="(order, index) in pastOrderList"
                  :class="'column is-12  is-12-mobile is-12-tablet '+(vg_currentOrder.id==order.id?'is-active':'')"
                  v-bind:key="'order_' + index"
                  @click="va_setCurrentOrder(order)"
                  
                > <!-- is-hidden-touch -->
                  <a class="is-flex is-flex-column align-items-start">
                    <span class="tab-label">Order #{{order.id}}</span>
                    <span class="order-timestamp">
                      <span class="order-time">{{orderTime(order)}}</span>,
                      <span class="order-date">{{orderDate(order)}}</span>
                    </span>
                  </a>
                </li>
              </template>
              <template v-else>
                <li
                  v-for="(order, index) in upcomingOrderList"
                  :class="'column is-12  is-12-mobile is-12-tablet '+(vg_currentOrder.id==order.id?'is-active':'')"
                  v-bind:key="'order_' + index"
                  @click="va_setCurrentOrder(order)"
                ><!-- is-hidden-touch -->
                
                  <a class="is-flex is-flex-column align-items-start">
                    <span class="tab-label">Order #{{order.id}}</span>
                    <span class="order-timestamp">
                      <span class="order-time">{{orderTime(order)}}</span>,
                      <span class="order-date">{{orderDate(order)}}</span>
                    </span>
                  </a>
                </li>
              </template>
              <!-- empty past order -->
              <li
                class="column is-12 is-12-mobile is-12-tablet is-hidden-touch"
                v-if="!loading && vg_activeTab == 'past'  && pastOrderList.length < 1"
              >
                <a class="is-flex is-flex-column align-items-start">
                  <span class="tab-label">No order available.</span>
                </a>
              </li>
              <!-- empty upcoming order -->
              <li
                class="column is-12 is-12-mobile is-12-tablet is-hidden-touch"
                v-if="!loading && vg_activeTab == 'coming' && upcomingOrderList.length < 1"
              >
                <a class="is-flex is-flex-column align-items-start">
                  <span class="tab-label">No order available.</span>
                </a>
              </li>

              
            </ul>
          </div>

          <!-- Order Results -->
          <div class="column is-9-tablet is-10-desktop section-search-results">
            <section class="columns is-flex is-centered">
              <past-order :review="review" v-if="vg_activeTab == 'past'"></past-order>
              <upcoming-order v-if="vg_activeTab == 'coming'" :review="review"></upcoming-order>
            </section>
          </div>
        </div>
      </main>

      <app-footer></app-footer>
      <order-receipt></order-receipt>
    </div>
  </div>
</template>
<script>
import OrderReceipt from "@/Components/Pages/User/Order/OrderReceipt";
import PastOrder from "@/Components/Pages/User/Order/PastOrder";
import UpcomingOrder from "@/Components/Pages/User/Order/UpcomingOrder";
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import { mapGetters, mapActions } from "vuex";
import { format } from "date-fns";
import { filter, isEmpty } from "lodash";
import moment from 'moment';
import 'moment-timezone';

export default {
  name: "UserOrderHistory",
  components: {
    OrderReceipt,
    PastOrder,
    UpcomingOrder
  },
  
  data() {
    return {
      review: false,
      status: "",
      pastOrder: true,
      orderList: [],
      pastOrderList: [],
      upcomingOrderList: [],
      loading: true,
    };
  },

  computed: {
    ...mapGetters({
      // getLoggedInUser: "getLoggedInUser",
      vg_currentOrder: "orderhistory/currentOrder",
      vg_activeTab: "orderhistory/activeTab",
      vg_allOrders: "orderhistory/allOrders",
      vg_orderCurrentPage: "orderhistory/orderCurrentPage",
      vg_selectedStore: "location/selected",
    })
  },
  
  async mounted() {
     // get order data from api
    this.va_setOrderCurrentPage(1);
    await this.fetchOrderHistory(this.vg_orderCurrentPage);
    // set first order as active and as current order
    if (this.pastOrderList && this.pastOrderList.length > 0) {
      this.va_setCurrentOrder(this.pastOrderList[0]);
    }

    if(this.vg_activeTab == ''){
      this.switchOrderTab('past'); 
    }
    // check the status of active order
    if(this.vg_currentOrder.status == 'completed' || this.vg_currentOrder.status == 'cancelled'){
      this.va_setCurrentOrder({});
      this.switchOrderTab('past');
    }
    
    // listen on event if any orders got completed and is active
    bus.$on('update-order-status-refetch', async (payload) => {
      this.va_setOrderCurrentPage(1);
      await this.fetchOrderHistory(this.vg_orderCurrentPage);
      this.va_setActiveTab('past');
      this.va_setCurrentOrder(payload);
    })
    this.fetchPaginateData();
  },
  
  beforeDestroy() {
    bus.$off('update-order-status-refetch');
  },

  methods: {
   
    /**
     * Manage scroll and hit api
     */
    fetchPaginateData() {
      const self = this;
      document.getElementById("height-400").addEventListener("scroll",  async () => {
        let sectionheight = document.getElementById("height-400").clientHeight; // section height
        let pageFromTop = document.getElementById("height-400").scrollTop; // scrolled section height
        if(sectionheight - pageFromTop <= 50){
          if(self.vg_allOrders.total_page - self.vg_orderCurrentPage > 0){
            self.va_setOrderCurrentPage(self.vg_orderCurrentPage + 1);
            await self.fetchOrderHistory(this.vg_orderCurrentPage);
            self.reinit()
          }
        }
      });
    },

    reinit() {
      const self = this;
      document.getElementById("height-400").removeEventListener("scroll", () => {}, false);  
      setTimeout(()=> {
        self.fetchPaginateData();
      }, 3000)
    },

    /**
    * Switch order tab
     */
     async switchOrderTab(val) {
      this.va_setOrderCurrentPage(1);
      this.fetchOrderHistory(this.vg_orderCurrentPage);
      this.va_setActiveTab(val);
      // Make first item auto select
      let obj = {};
      if(val === 'past') { 
        obj = this.pastOrderList.length > 0 ? this.pastOrderList[0] : {};
      } else {
        obj = this.upcomingOrderList.length > 0 ? this.upcomingOrderList[0] : {};
      }
      this.va_setCurrentOrder(obj);
     },
    /**
     * Fetch past all orders
     */
    async fetchOrderHistory(page) {

      if(page == 1 && this.vg_allOrders.orders.length < 1){
        this.loading = true;
      }
      let res = await OrderHistoryApis.fetch(page);
      this.loading = false;
      if(res.status == 200){
        if(this.vg_orderCurrentPage == 1) {
          this.va_setAllOrders(res.data.payload);
        } else {
          this.va_addNewOrderItems(res.data.payload);
        }
        // Separate 
        this.enlistPastOrder(this.vg_allOrders.orders);
        this.enlistUpcomingOrder(this.vg_allOrders.orders);
      }
     
    },


    // Get order time and date
    orderTime(order) {
      if (!order || order.created_at == null) return;
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto').format('h:mm a');
    },

    // get order date
    orderDate(order) {
      if (!order) return;
      return moment.utc(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto').format('MMM DD YYYY');
    },

    // filter past order list
    enlistPastOrder(orders) {
      if (!orders) return;
       this.pastOrderList =  _.filter(orders, function(order) {
        return order.status =='completed' || order.status =='cancelled';
      });
    },

    // filter upcomming order list
    enlistUpcomingOrder(orders) {
      if (!orders) return;
     this.upcomingOrderList =  _.filter(orders, function(order) {
        return order.status =='pending' || order.status =='ready' || order.status =='preparing';
      });
    },

    // // set current Order
    // va_setCurrentOrder(order) {
    //   this.va_setCurrentOrder(order);
    // },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },
    
    ...mapActions({
      va_setCurrentOrder: "orderhistory/setCurrentOrder",
      va_setActiveTab: "orderhistory/setActiveTab",
      va_setAllOrders: "orderhistory/setAllOrders",
      va_setOrderCurrentPage: "orderhistory/setOrderCurrentPage",
      va_addNewOrderItems: "orderhistory/addNewOrderItems",
    })
  }
};
</script>

<style scoped>
.height-400 {
    max-height: calc(100vh - 200px); 
    /* max-height: 200px; */
    overflow-y: auto;
    min-height:50px;
}

.hv-center{
    text-align: center;
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
}
.custom-scroll::-webkit-scrollbar {
  width: 3px;
}
 
.custom-scroll::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
}
 
.custom-scroll::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}


@media only screen and (max-width: 991px) {
  .height-400 {
      max-height: 386px;
  }
}
@media only screen and (max-width: 768px) {
  .height-400 {
      max-height: 300px;
  }
}
</style>